@if (confirmation.modal$ | async; as modal) {
<div class="confirmation-overlay" (click)="modal.closeOnBackdrop ? confirmation.cancel() : null">
    <div class="confirmation-dialog" (click)="$event.stopPropagation()">
        <div class="header">
            <div class="icon" [class.info]="modal.type === 'info'" [class.success]="modal.type === 'success'"
                [class.warning]="modal.type === 'warning'" [class.danger]="modal.type === 'danger'">

                @switch (modal.type) {

                @case ('danger') {

                🗑️

                }

                @case ('warning') {

                ⚠️

                }

                @case ('success') {

                ✅

                }

                @default {

                ℹ️

                }

                }

            </div>

            <h2>

                {{ modal.title }}

            </h2>

        </div>

        <div class="body">

            {{ modal.message }}

        </div>

        <div class="footer">

            <button class="secondary" (click)="confirmation.cancel()">

                {{ modal.cancelText }}

            </button>

            <button class="primary" [class.danger]="modal.type === 'danger'" [class.warning]="modal.type === 'warning'"
                [class.success]="modal.type === 'success'" (click)="confirmation.confirm()">

                {{ modal.confirmText }}

            </button>

        </div>

    </div>

</div>

}